var map = {
	"./BALL0001.jpg": "4599",
	"./BALL0002.jpg": "ac7a",
	"./BALL0003.jpg": "7806",
	"./BALL0004.jpg": "1824",
	"./BALL0005.jpg": "57be",
	"./BALL0006.jpg": "3d65",
	"./BALL0007.jpg": "eab2",
	"./BALL0008.jpg": "5d63",
	"./BALL0009.jpg": "ef68",
	"./BALL0010.jpg": "e5e1",
	"./BALL0011.jpg": "126f",
	"./BALL0012.jpg": "da09",
	"./BALL0013.jpg": "7d2f",
	"./BALL0014.jpg": "331b",
	"./BALL0015.jpg": "261f",
	"./BALL0016.jpg": "f228",
	"./BALL0017.jpg": "fe5c",
	"./BALL0018.jpg": "38bb",
	"./BALL0019.jpg": "2e1d",
	"./BALL0020.jpg": "2eef",
	"./BALL0021.jpg": "4cd4",
	"./BALL0022.jpg": "e065",
	"./BALL0023.jpg": "4699",
	"./BALL0024.jpg": "4d27",
	"./BALL0025.jpg": "ce9c",
	"./BALL0026.jpg": "7dbc",
	"./BALL0027.jpg": "b372",
	"./BALL0028.jpg": "a4a5",
	"./BALL0029.jpg": "6cea",
	"./BALL0030.jpg": "831a",
	"./BALL0031.jpg": "d7d0",
	"./BALL0032.jpg": "5f73",
	"./BALL0033.jpg": "5c3b",
	"./BALL0034.jpg": "9547",
	"./BALL0035.jpg": "f2ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c6a";